export const FETCH_VPN_STATUS = 'ipfabric/vpn/FETCH_VPN_STATUS';
export const VPN_START = 'ipfabric/vpn/VPN_START';
export const VPN_STOP = 'ipfabric/vpn/VPN_STOP';

export const CONNECTED_ENUM = {
  unknown: 'unknown',
  connected: 'connected',
  disconnected: 'disconnected',
};
